/**
 * Rileva il brand dall'URL.
 * @param {string} [url=window.location.href] - L'URL da analizzare.
 * @returns {string} Il brand rilevato (es. "vianova", "kalliope" o stringa vuota).
 */
export function getBrand(url = window.location.href) {
    switch (true) {
        case url.includes('.vianova.it'):
            return 'vianova';
        case url.includes('.kalliope.cloud'):
            return 'kalliope';
        default:
            return '';
    }
}
/**
 * Restituisce il brand solo per quelli che non sono Vianova.
 * Vianova ad ora segue il flusso senza brandizzazione (verso areaclienti-ws)
 */
export function getBrandForLogin(url = window.location.href) {
    const brand = getBrand(url);
    return brand === 'kalliope' ? `[${brand}]` : '';
}
